import React from 'react';
import {useParams} from 'react-router-dom';

export default function Report() {

  const {scheduleId} = useParams();

  return (
    <>
      <h3>Audit Report</h3>
      <a href={`${process.env.REACT_APP_API_HOST}schedules/${scheduleId}/generate-report`} className="btn btn-primary">Generate</a>
    </>
  )
}